<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBItemTypeForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBItemTypeList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBItemTypeForm from './Form.vue'

export default {
  components: {
    EXSBItemTypeForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbitemtype/update/isLoading',
      error: 'exsbitemtype/update/error',
      deleteError: 'exsbitemtype/del/error',
      deleteLoading: 'exsbitemtype/del/isLoading',
      created: 'exsbitemtype/create/created',
      deleted: 'exsbitemtype/del/deleted',
      retrieved: 'exsbitemtype/update/retrieved',
      updated: 'exsbitemtype/update/updated',
      violations: 'exsbitemtype/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBItemTypeList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbitemtype/create/reset',
      deleteItem: 'exsbitemtype/del/del',
      delReset: 'exsbitemtype/del/reset',
      retrieve: 'exsbitemtype/update/retrieve',
      updateReset: 'exsbitemtype/update/reset',
      update: 'exsbitemtype/update/update',
      updateRetrieved: 'exsbitemtype/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbitemtype ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
